import Tr from 'translations/Translations';

export const ContractorVerificationOfferStatus = {
    ALLOWED: "ALLOWED",
    ALLOWED_PARTIALLY: "ALLOWED_PARTIALLY",
    EXCLUDED: "EXCLUDED",
    REVERSE_PROCEDURE: "REVERSE_PROCEDURE",
    OFFER_REJECTED: "OFFER_REJECTED",
    NOT_SCORED: "NOT_SCORED",
    NOT_VERIFIED: "NOT_VERIFIED"
}
const _TR_PREFIX = 'contractor_verification_offer_status_';

export const ContractorVerificationOfferStatusLabel = (status) => (Tr(_TR_PREFIX + status.toLowerCase()));
